import React from 'react';
import PropTypes from 'prop-types';
import './card-content-section-details.scss';

const CardContentSectionDetails = ({ isLoading, details }) => {
  const sectionDetails = details && details.map((item, i) => (
    <div key={i}>
      <span>
        {item.section}
      </span>
      <div className="section-item">
        {
          item.data &&
          item.data.map((d, i) => (
            <div key={i}>
              <div id="title">
                {d.key}
              </div>
              <div id="value">
                {!d.link ? d.value : <button className='icon-button' onClick={()=> d.onClick?.(d.value)}>{d.value}</button> }
              </div>
            </div>
          ))
        }
      </div>
    </div>
  ));

  return (
    <div className="section-details">
      {isLoading ? 'Loading ...' : sectionDetails}
    </div>
  );
};

CardContentSectionDetails.propTypes = {
  details: PropTypes.array
};


export default CardContentSectionDetails;